if (typeof Object.assign != 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target, varArgs) { // .length of function is 2
      'use strict';
      if (target == null) { // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource != null) { // Skip over if undefined or null
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

function KR_Chart($, elementId, typeId, data, customOptions) {
  this.elementId = elementId;
  this.typeId = typeId;
  this.data = data;
  this.options = customOptions;

  var self = this,
      windowResizeTimeout,
      chartConfig,
      $el = $('#'+elementId),
      chartWrapper;

  // Set chart options
  var defaultOptions = { 
    //'title': title,
    //'width':400,
    //'height':300,
    //legend: { maxLines: 1, alignment: 'center' },
    //colors: ['#c4161c','#1565c0','#fab500','#64c2c8','#d81b60','#d4e157','#ab47bc','#ff6e40','#651FFF','#84ffff','#dcedc8','#8c9eff','#00b8d4','#fff3e0'],
    //vAxis: { title: chartOptions.vAxis.title, titleTextStyle: { italic: false, fontSize: 25 } },
    //hAxis: { title: chartOptions.hAxis.title, titleTextStyle: { italic: false, fontSize: 25 } },
    //tooltip: { isHtml: true }
    //colors: ['#2b579e','#434d89','#5c4274','#75385f','#8e2d49','#a82435','#b4202e','#c4161c','#ca3322','#d44c22','#dd6622','#e68024','#ef9927','#fab500']
    //colors: ['#890f14','#a71218','#c4161c','#ce4b50','#d88184','#e1b6b7','#ebebeb']
  };

  this.drawChart = function() {
    if (typeof google === 'undefined') {
      return;
    }
  
    /*if (chartConfig === undefined) {
      throw 'Invalid typeId';
    }*/
  
    var data = google.visualization.arrayToDataTable(self.data || [], false);
    
    self.chartWrapper = new google.visualization.ChartWrapper({
      chartType: chartConfig.type,
      dataTable: data,
      options: self.options,
      containerId: self.elementId
    });
  
    google.visualization.events.addListener(self.chartWrapper, 'ready', function() {
      window.dispatchEvent(KR_Chart.chartReadyEvent);
    });
  
    self.chartWrapper.draw();
  
    google.visualization.events.addListener(self.chartWrapper, 'ready', function() {
      window.removeEventListener('resize', windowResizeHandler, false);
      window.addEventListener('resize', windowResizeHandler, false);
    });
  }

  function windowResizeHandler() {
    clearTimeout(windowResizeTimeout);
    windowResizeTimeout = setTimeout(function() {
      //var opts = self.chartWrapper.getOptions();
      //setResponsiveOptions(opts);
      //self.chartWrapper.setOptions(opts);
      if ($el.is(':visible')) {
        self.drawChart();
      }
    }, 100);
  }

  function setResponsiveOptions(options) {
    if (window.innerWidth < 768) { //sm-max
      if (self.options.bar && self.options.bar.groupWidth) {
        self.options.bar.groupWidth = '70%';
      }
    }
    /*if (window.innerWidth < 480) { //xs-max
      self.options.vAxis.titleTextStyle.fontSize = 14;
      self.options.hAxis.titleTextStyle.fontSize = 14;
    } else { //sm-min
      self.options.vAxis.titleTextStyle.fontSize = 25;
      self.options.hAxis.titleTextStyle.fontSize = 25;
    }
  
    if (window.innerWidth < 768) { //sm-max
      if (self.options.chartArea && self.options.chartArea.left) {
        self.options.chartArea.left = '20%';
        self.options.chartArea.width = '80%';
      }
    } else { // md-min
      if (self.options.chartArea && self.options.chartArea.left) {
        self.options.chartArea.left = '10%';
        self.options.chartArea.width = '90%';
      }
    }*/
  }

  function init() {
    chartConfig = KR_Chart.chartTypes.filter(function(value) {
      return value.id === typeId;
    })[0];

    // merge global default options with chart default options 
    self.options = Object.assign(defaultOptions, chartConfig.options);

    // merge chart default options with specified options
    self.options = Object.assign(self.options, customOptions);

    // add responsive options
    setResponsiveOptions(self.options);
  }

  init();
}

KR_Chart.chartReadyEvent = document.createEvent('Event');
KR_Chart.chartReadyEvent.initEvent('KR_Chart.chartReadyEvent', true, true);

KR_Chart.chartTypes = [
  { id: 1, label: 'Bar', type: 'BarChart', options: { legend: { position: 'top', alignment: 'end' }, chartArea: { left: '10%', top: '10%', height: '65%', width: '90%' } }  }, //bar:{groupWidth:'40%'}
  //{ id: 11, label: 'Bubble', type: 'BubbleChart', options: {} },
  { id: 2, label: 'Column', type: 'ColumnChart', options: { legend: { position: 'top', alignment: 'end'}, chartArea: { left: '10%', top: '10%', height: '65%', width: '90%' } }  },
  //{ id: 3, label: 'Combo', type: 'ComboChart', options: {} },
  { id: 4, label: 'Donut', type: 'PieChart', options: { pieHole: 0.7, pieSliceText: 'none', chartArea: { height: '94%', width: '94%' } }  },
  //{ id: 10, label: 'Geo', type: 'GeoChart', options: {} },
  //{ value: '', label: 'Gauge' },
  { id: 5, label: 'Line', type: 'LineChart', options: { pointSize: 7, pointShape: { type: 'circle'}, legend: { position: 'top', alignment: 'end'}, chartArea: { left: '10%', top: '10%', height: '65%', width: '90%' } }  },
  { id: 6, label: 'Pie', type: 'PieChart', options: { chartArea: { height: '94%', width: '94%' } }  },
  { id: 7, label: 'Stacked', type: 'ColumnChart', options: { isStacked: true } },
  //{ id: 8, label: 'Stacked - Horizontal', type: '', options: {} },
  //{ id: 9, label: 'Tree', type: 'TreeMap', options: { minColor: '#2b579e', midColor: '#fab500', maxColor: '#890f14' } }
];


function KR($) {
  var self = this;
  var entLogoBaseUrl = (window.krTheme && window.krTheme.entLogoBaseUrl) ? window.krTheme.entLogoBaseUrl : '/images/entlogos/';

  this.charts = [];

  function drawRivalryRecipes() {
    if (typeof d3 === 'undefined') {
      return;
    }

    $('.kr-rivalry-recipe-chart').each(function() {
      var $chart = $(this),
          $chartWrap = $chart.closest('.kr-rivalry-recipe-chart-wrap'),
          $centerOverlay = $chartWrap.find('.kr-rivalry-recipe-center-overlay'),
          $centerLogo = $chartWrap.find('.kr-rivalry-recipe-center-logo-img'),
          $recipe = $chart.closest('.kr-rivalry-recipe'),
          $keyItems = $recipe.find('.kr-rivalry-recipe-key-item'),
          rawData = $chart.attr('data-chart'),
          payload;

      if (!rawData) {
        return;
      }

      try {
        payload = JSON.parse(rawData);
      } catch (error) {
        return;
      }

      var config = payload.config || {},
          team1Id = Number(payload.team1Id || 0),
          team2Id = Number(payload.team2Id || 0),
          ingredients = (payload.ingredients || []).map(function(ingredient) {
            return {
              label: ingredient.label,
              slug: ingredient.slug || '',
              team1: Number(ingredient.team1 || 0),
              team2: Number(ingredient.team2 || 0)
            };
          });

      if (!ingredients.length) {
        return;
      }

      var containerWidth = Math.round($chartWrap.innerWidth() || $chart.innerWidth() || 520),
          width = Math.max(320, Math.min(containerWidth, 520)),
          extraVerticalSpace = width < 640 ? 96 : 32,
          height = width + extraVerticalSpace,
          outerRadius = Math.min(width, height) * 0.42,
          labelRadius = outerRadius + 28,
          innerRadius = 56,
          ringCount = Number(config.maxPoints || 10),
          ringStep = (outerRadius - innerRadius) / ringCount,
          gapAngle = 0.025,
          ingredientAngle = (Math.PI * 2) / ingredients.length,
          startIndex = Number(config.startIndex || 0),
          rotationOffset = ingredientAngle * startIndex,
          teamGap = 0.012,
          centerLogoSize = width < 640 ? 32 : 40,
          centerLogoOffset = width < 640 ? 6 : 11,
          centerXRatio = 0.5,
          centerYRatio = ((width / 2) + (extraVerticalSpace / 3)) / height;

      function getTeamLogoUrl(entId) {
        if (!entId) {
          return '';
        }

        return entLogoBaseUrl + 'logo_ent' + entId + '.svg';
      }

      var selectedSlug = ingredients.reduce(function(bestSlug, ingredient, index) {
            var teamValue = ingredient.team1;

            if (index === 0) {
              ingredient._team1Value = teamValue;
              return ingredient.slug;
            }

            ingredient._team1Value = teamValue;

            var bestIngredient = ingredients.find(function(candidate) {
              return candidate.slug === bestSlug;
            });

            return teamValue > (bestIngredient ? bestIngredient._team1Value : -Infinity) ? ingredient.slug : bestSlug;
          }, ''),
          activeSlug = null,
          selectedCenterState = null,
          selectedBarNode = null;

      $chart.empty();

      var svg = d3.select(this)
        .append('svg')
        .attr('width', width)
        .attr('height', height)
        .attr('viewBox', [0, 0, width, height])
        .attr('preserveAspectRatio', 'xMidYMid meet')
        .attr('role', 'img')
        .attr('aria-label', config.title || 'Rivalry recipe chart');

      var root = svg.append('g')
        .attr('transform', 'translate(' + (width / 2) + ',' + ((width / 2) + (extraVerticalSpace / 3)) + ')');

      $centerOverlay.css({
        left: (centerXRatio * 100) + '%',
        top: 'calc(' + (centerYRatio * 100) + '% + ' + centerLogoOffset + 'px)'
      });

      $centerLogo.css({
        width: centerLogoSize + 'px',
        height: centerLogoSize + 'px'
      });

      for (var ringIndex = 1; ringIndex <= ringCount; ringIndex += 1) {
        root.append('circle')
          .attr('r', innerRadius + (ringStep * ringIndex))
          .attr('fill', 'none')
          .attr('stroke', '#e6e7eb')
          .attr('stroke-width', 1);
      }

      function setCenterValue(value, color, entId) {
        centerLabel
          .text(value)
          .attr('fill', color || '#0f172a');

        if (entId > 0) {
          $centerLogo.attr('src', getTeamLogoUrl(entId));
          $centerOverlay.addClass('is-visible');
        } else {
          $centerLogo.attr('src', '');
          $centerOverlay.removeClass('is-visible');
        }
      }

      function clearCenterValue() {
        centerLabel.text('');
        $centerLogo.attr('src', '');
        $centerOverlay.removeClass('is-visible');
      }

      function applySelectedBar(node) {
        root.selectAll('.kr-rivalry-recipe-bar')
          .classed('is-selected-bar', false)
          .style('color', null);

        if (node) {
          d3.select(node)
            .classed('is-selected-bar', true)
            .style('color', d3.select(node).attr('fill') || null);
        }
      }

      function restoreSelectedState() {
        if (selectedCenterState) {
          setCenterValue(selectedCenterState.value, selectedCenterState.color, selectedCenterState.entId);
          applySelectedBar(selectedBarNode);
          return;
        }

        clearCenterValue();
        applySelectedBar(null);
      }

      function renderIngredientState() {
        var currentSlug = activeSlug || selectedSlug;

        root.selectAll('.kr-rivalry-recipe-ingredient')
          .classed('is-active', function() {
            return currentSlug && this.getAttribute('data-ingredient-slug') === currentSlug;
          })
          .classed('is-selected', function() {
            return selectedSlug && this.getAttribute('data-ingredient-slug') === selectedSlug;
          });

        $keyItems.each(function() {
          var $item = $(this),
              slug = $item.data('ingredient-slug');

          $item.toggleClass('is-active', !!currentSlug && slug === currentSlug);
          $item.toggleClass('is-selected', !!selectedSlug && slug === selectedSlug);
        });
      }

      function setActiveIngredient(slug) {
        activeSlug = slug || null;
        renderIngredientState();
      }

      function setSelectedIngredient(slug) {
        if (!slug) {
          return;
        }

        selectedSlug = slug;
        renderIngredientState();
      }

      function setSelectedIngredientTeamState(slug, value, color, entId, node) {
        setSelectedIngredient(slug);
        setActiveIngredient(slug);
        selectedCenterState = {
          value: d3.format('.1f')(value),
          color: color,
          entId: entId
        };
        selectedBarNode = node || null;
        setCenterValue(selectedCenterState.value, selectedCenterState.color, selectedCenterState.entId);
        applySelectedBar(selectedBarNode);
      }

      function bindIngredientHighlight(selection, slug, defaultValue, defaultColor, defaultEntId, defaultNode) {
        selection
          .attr('tabindex', 0)
          .attr('role', 'img')
          .attr('aria-label', 'Highlight ' + slug.replace(/-/g, ' '))
          .on('mouseenter', function() {
            setActiveIngredient(slug);
          })
          .on('mouseleave', function() {
            setActiveIngredient(null);
            restoreSelectedState();
          })
          .on('focus', function() {
            setActiveIngredient(slug);
          })
          .on('blur', function() {
            setActiveIngredient(null);
            restoreSelectedState();
          })
          .on('click', function() {
            setSelectedIngredientTeamState(slug, defaultValue, defaultColor, defaultEntId, defaultNode);
          });
      }

      function bindIngredientInteraction(selection, teamLabel, value, color, slug, entId) {
        selection
          .attr('tabindex', 0)
          .attr('role', 'img')
          .attr('aria-label', teamLabel + ': ' + value)
          .on('mouseenter', function() {
            root.selectAll('.kr-rivalry-recipe-bar').classed('is-hovered-bar', false);
            d3.select(this).classed('is-hovered-bar', true);
            setActiveIngredient(slug);
            setCenterValue(d3.format('.1f')(value), color, entId);
          })
          .on('mouseleave', function() {
            d3.select(this).classed('is-hovered-bar', false);
            setActiveIngredient(null);
            restoreSelectedState();
          })
          .on('focus', function() {
            root.selectAll('.kr-rivalry-recipe-bar').classed('is-hovered-bar', false);
            d3.select(this).classed('is-hovered-bar', true);
            setActiveIngredient(slug);
            setCenterValue(d3.format('.1f')(value), color, entId);
          })
          .on('blur', function() {
            d3.select(this).classed('is-hovered-bar', false);
            setActiveIngredient(null);
            restoreSelectedState();
          })
          .on('click', function() {
            setSelectedIngredientTeamState(slug, value, color, entId, this);
          });
      }

      $keyItems.off('.krRivalryRecipe').on('mouseenter.krRivalryRecipe focusin.krRivalryRecipe', function() {
        var $item = $(this),
            slug = $item.data('ingredient-slug');

        setActiveIngredient(slug);
        setSelectedIngredient(slug);
      }).on('mouseleave.krRivalryRecipe focusout.krRivalryRecipe', function() {
        setActiveIngredient(null);
        restoreSelectedState();
      });

      ingredients.forEach(function(ingredient, index) {
        var startAngle = (index * ingredientAngle) - (Math.PI / 2) - rotationOffset + gapAngle,
            endAngle = ((index + 1) * ingredientAngle) - (Math.PI / 2) - rotationOffset - gapAngle,
            midAngle = (startAngle + endAngle) / 2,
            teamMid = (startAngle + endAngle) / 2,
            team1Arc = d3.arc()
              .innerRadius(innerRadius)
              .outerRadius(innerRadius + (ringStep * ingredient.team1))
              .startAngle(startAngle)
              .endAngle(teamMid - teamGap),
            team2Arc = d3.arc()
              .innerRadius(innerRadius)
              .outerRadius(innerRadius + (ringStep * ingredient.team2))
              .startAngle(teamMid + teamGap)
              .endAngle(endAngle);

        var ingredientGroup = root.append('g')
          .attr('class', 'kr-rivalry-recipe-ingredient')
          .attr('data-ingredient-slug', ingredient.slug);

        var ingredientBackground = ingredientGroup.append('path')
          .attr('class', 'kr-rivalry-recipe-slice-bg')
          .attr('d', d3.arc()
            .innerRadius(innerRadius)
            .outerRadius(outerRadius)
            .startAngle(startAngle)
            .endAngle(endAngle)())
          .attr('fill', '#0f172a')
          .attr('fill-opacity', 0.03);

        var team1Path = ingredientGroup.append('path')
          .attr('class', 'kr-rivalry-recipe-bar kr-rivalry-recipe-bar-team-1')
          .attr('d', team1Arc())
          .attr('fill', config.team1Color || '#0f274f')
          .attr('fill-opacity', 0.9);

        var team2Path = ingredientGroup.append('path')
          .attr('class', 'kr-rivalry-recipe-bar kr-rivalry-recipe-bar-team-2')
          .attr('d', team2Arc())
          .attr('fill', config.team2Color || '#cf3b2f')
          .attr('fill-opacity', 0.8);

        var ingredientDisplayLabel = ingredient.shortTitle || ingredient.label;

        bindIngredientInteraction(
          team1Path,
          (config.team1Label || 'Team 1') + ' - ' + ingredientDisplayLabel,
          ingredient.team1,
          config.team1Color || '#0f274f',
          ingredient.slug,
          team1Id
        );

        bindIngredientInteraction(
          team2Path,
          (config.team2Label || 'Team 2') + ' - ' + ingredientDisplayLabel,
          ingredient.team2,
          config.team2Color || '#cf3b2f',
          ingredient.slug,
          team2Id
        );

        bindIngredientHighlight(
          ingredientBackground,
          ingredient.slug,
          ingredient.team1,
          config.team1Color || '#0f274f',
          team1Id,
          team1Path.node()
        );

        if (ingredient.slug === selectedSlug) {
          selectedCenterState = {
            value: d3.format('.1f')(ingredient.team1),
            color: config.team1Color || '#0f274f',
            entId: team1Id
          };
          selectedBarNode = team1Path.node();
        }

        root.append('path')
          .attr('d', d3.arc()
            .innerRadius(innerRadius)
            .outerRadius(outerRadius)
            .startAngle(startAngle - gapAngle)
            .endAngle(startAngle - gapAngle + 0.002)())
          .attr('fill', '#d9dce3');

        var labelPoint = d3.arc()
              .innerRadius(labelRadius)
              .outerRadius(labelRadius)
              .startAngle(startAngle)
              .endAngle(endAngle)
              .centroid(),
            labelRotation = ((midAngle * 180 / Math.PI) + 360) % 360;

        if (labelRotation > 90 && labelRotation < 270) {
          labelRotation += 180;
        }

        ingredientGroup.append('text')
          .attr('class', 'kr-rivalry-recipe-label')
          .attr('data-ingredient-slug', ingredient.slug)
          .attr('text-anchor', 'middle')
          .attr('dominant-baseline', 'middle')
          .attr('transform', 'translate(' + labelPoint[0] + ',' + labelPoint[1] + ') rotate(' + labelRotation + ')')
          .text(ingredientDisplayLabel);
      });

      root.append('circle')
        .attr('r', innerRadius - 4)
        .attr('fill', '#fff')
        .attr('stroke', '#d9dce3')
        .attr('stroke-width', 1.25);

      var centerLabel = root.append('text')
        .attr('class', 'kr-rivalry-recipe-center-label')
        .attr('text-anchor', 'middle')
        .attr('dominant-baseline', 'middle')
        .attr('y', -12)
        .text('');

      renderIngredientState();
      restoreSelectedState();
    });
  }

  function drawHostilityCharts() {
    if (typeof d3 === 'undefined') {
      return;
    }

    function escapeAttr(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }

    function formatHostilityValue(value) {
      var numericValue = parseFloat(value);

      if (!numericValue) {
        return 'N/A';
      }

      return d3.format('.1f')(numericValue);
    }

    $('.kr-hostility-chart').each(function() {
      var $chart = $(this),
          rawData = $chart.attr('data-chart'),
          payload;

      if (!rawData) {
        return;
      }

      try {
        payload = JSON.parse(rawData);
      } catch (error) {
        return;
      }

      var config = payload.config || {},
          rows = payload.rows || [];

      if (!rows.length) {
        return;
      }

      var showVsLink = config.showVsLink !== false;

      var rowHeight = 98,
          minValue = 1,
          maxValue = Number(config.maxValue || 7),
          barGap = 18,
          barHeight = 20,
          barsTop = 8,
          logoSize = 40,
          linkBoxSize = 36,
          rivalryLinkGap = 20,
          baseMarginLeft = 120,
          hiddenLinkOffset = showVsLink ? 0 : (linkBoxSize + rivalryLinkGap),
          margin = { top: 12, right: 70, bottom: 20, left: baseMarginLeft - hiddenLinkOffset },
          width = Math.max(700, $chart.innerWidth() || 700),
          innerWidth = width - margin.left - margin.right,
          height = (rows.length * rowHeight) + margin.top + margin.bottom,
          logoOffsetX = -(logoSize + 12),
          linkOffsetX = logoOffsetX - rivalryLinkGap - linkBoxSize;

      $chart.empty();

      var svg = d3.select(this)
        .append('svg')
        .attr('viewBox', [0, 0, width, height])
        .attr('role', 'img')
        .attr('aria-label', (config.title || 'Hostility') + ' chart');

      var root = svg.append('g')
        .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

      var x = d3.scaleLinear()
        .domain([minValue, maxValue])
        .range([0, innerWidth]);

      function getHostilityBarWidth(value) {
        var numericValue = parseFloat(value);

        if (!numericValue || numericValue <= minValue) {
          return 0;
        }

        return x(Math.min(numericValue, maxValue)) - x(minValue);
      }

      function getHostilityBarLabelX(value) {
        var numericValue = parseFloat(value);

        if (!numericValue || numericValue <= minValue) {
          return x(minValue) + 8;
        }

        return x(Math.min(numericValue, maxValue)) + 8;
      }

      var y = d3.scaleBand()
        .domain(rows.map(function(row) { return row.rivalEntID; }))
        .range([0, rows.length * rowHeight])
        .paddingInner(0.28);

      var xAxis = d3.axisTop(x)
        .tickSize(-(rows.length * rowHeight))
        .tickValues(d3.range(minValue, maxValue + 1))
        .tickFormat(d3.format('d'));

      root.append('g')
        .attr('class', 'kr-hostility-axis')
        .call(xAxis)
        .call(function(axis) {
          axis.select('.domain').remove();
          axis.selectAll('line').attr('stroke', '#d9dce3');
          axis.selectAll('text').attr('fill', '#64748b');
        });

      var groups = root.selectAll('.kr-hostility-row')
        .data(rows)
        .enter()
        .append('g')
        .attr('class', 'kr-hostility-row')
        .attr('transform', function(row) {
          return 'translate(0,' + y(row.rivalEntID) + ')';
        });

      if (showVsLink) {
        groups.append('foreignObject')
          .attr('class', 'kr-hostility-rivalry-link-fo')
          .attr('x', linkOffsetX)
          .attr('y', barsTop + barHeight + (barGap / 2) - (linkBoxSize / 2))
          .attr('width', linkBoxSize)
          .attr('height', linkBoxSize)
          .append('xhtml:div')
          .attr('class', 'rivalry-link-cell kr-hostility-rivalry-link-cell')
          .html(function(row) {
            var href = row.rivalryUrl || '',
                vsGraphicMarkup = (window.krTheme && window.krTheme.rivalryVsGraphicMarkup) ? window.krTheme.rivalryVsGraphicMarkup : '';
            return '<a class="rivalry-meter-link kr-hostility-rivalry-link" href="' + escapeAttr(href) + '" aria-label="View rivalry data">' + vsGraphicMarkup + '</a>';
          });
      }

      groups.append('foreignObject')
        .attr('class', 'kr-hostility-team-logo-fo kr-hostility-team-logo-fo-forward')
        .attr('x', logoOffsetX)
        .attr('y', barsTop + (barHeight / 2) - (logoSize / 2))
        .attr('width', logoSize)
        .attr('height', logoSize)
        .append('xhtml:div')
        .attr('class', 'kr-hostility-team-logo-cell')
        .html(function(row) {
          var href = row.teamUrl || '',
              logoUrl = entLogoBaseUrl + 'logo_ent' + row.teamEntID + '.svg',
              label = row.teamName ? 'View ' + row.teamName + ' page' : 'View team page';

          return '<a class="kr-hostility-team-logo-link" href="' + escapeAttr(href) + '" aria-label="' + escapeAttr(label) + '"><img class="kr-hostility-team-logo kr-hostility-team-logo-forward" src="' + escapeAttr(logoUrl) + '" alt="" aria-hidden="true"></a>';
        });

      groups.append('foreignObject')
        .attr('class', 'kr-hostility-team-logo-fo kr-hostility-team-logo-fo-reverse')
        .attr('x', logoOffsetX)
        .attr('y', barsTop + barHeight + barGap + (barHeight / 2) - (logoSize / 2))
        .attr('width', logoSize)
        .attr('height', logoSize)
        .append('xhtml:div')
        .attr('class', 'kr-hostility-team-logo-cell')
        .html(function(row) {
          var href = row.rivalUrl || '',
              logoUrl = entLogoBaseUrl + 'logo_ent' + row.rivalEntID + '.svg',
              label = row.rivalName ? 'View ' + row.rivalName + ' page' : 'View rival team page';

          return '<a class="kr-hostility-team-logo-link" href="' + escapeAttr(href) + '" aria-label="' + escapeAttr(label) + '"><img class="kr-hostility-team-logo kr-hostility-team-logo-reverse" src="' + escapeAttr(logoUrl) + '" alt="" aria-hidden="true"></a>';
        });

      groups.append('rect')
        .attr('class', 'kr-hostility-bar kr-hostility-bar-forward')
        .attr('x', x(minValue))
        .attr('y', barsTop)
        .attr('rx', 6)
        .attr('ry', 6)
        .attr('width', function(row) { return getHostilityBarWidth(row.forwardValue); })
        .attr('height', barHeight)
        .attr('fill', function(row) { return row.teamColor; });

      groups.append('rect')
        .attr('class', 'kr-hostility-bar kr-hostility-bar-reverse')
        .attr('x', x(minValue))
        .attr('y', barsTop + barHeight + barGap)
        .attr('rx', 6)
        .attr('ry', 6)
        .attr('width', function(row) { return getHostilityBarWidth(row.reverseValue); })
        .attr('height', barHeight)
        .attr('fill', function(row) { return row.rivalColor; });

      groups.append('text')
        .attr('class', 'kr-hostility-bar-label kr-hostility-bar-label-forward')
        .attr('x', function(row) { return getHostilityBarLabelX(row.forwardValue); })
        .attr('y', barsTop + (barHeight / 2) + 5)
        .text(function(row) { return formatHostilityValue(row.forwardValue); });

      groups.append('text')
        .attr('class', 'kr-hostility-bar-label kr-hostility-bar-label-reverse')
        .attr('x', function(row) { return getHostilityBarLabelX(row.reverseValue); })
        .attr('y', barsTop + barHeight + barGap + (barHeight / 2) + 5)
        .text(function(row) { return formatHostilityValue(row.reverseValue); });

    });
  }

  function initRivalryMeterHelp() {
    var $tooltip = $('#kr-rivalry-meter-tooltip');

    if ($tooltip.length === 0) {
      $tooltip = $('<div id="kr-rivalry-meter-tooltip" class="kr-rivalry-meter-tooltip" role="tooltip" aria-hidden="true"></div>').appendTo('body');
    }

    function hideTooltip() {
      $tooltip.removeClass('is-visible').attr('aria-hidden', 'true').empty();
    }

    function positionTooltip($trigger) {
      var offset = $trigger.offset();
      if (!offset) {
        return;
      }

      var top = offset.top + $trigger.outerHeight() + 10;
      var left = offset.left + ($trigger.outerWidth() / 2) - ($tooltip.outerWidth() / 2);
      var maxLeft = $(window).width() - $tooltip.outerWidth() - 12;

      left = Math.max(12, Math.min(left, maxLeft));

      $tooltip.css({
        top: top,
        left: left
      });
    }

    $(document)
      .off('.krRivalryMeterHelp')
      .on('mouseenter.krRivalryMeterHelp focusin.krRivalryMeterHelp', '.rivalry-meter-help', function() {
        var $trigger = $(this),
            containerId = $trigger.data('def-container-id') || 'terms-defs',
            definitionId = $trigger.data('def-id'),
            $content = $('#' + containerId).find('#' + definitionId).first();

        if (!definitionId || $content.length === 0) {
          hideTooltip();
          return;
        }

        $tooltip.html($content.html()).addClass('is-visible').attr('aria-hidden', 'false');
        positionTooltip($trigger);
      })
      .on('mouseleave.krRivalryMeterHelp focusout.krRivalryMeterHelp', '.rivalry-meter-help', function() {
        hideTooltip();
      });

    $(window).off('scroll.krRivalryMeterHelp resize.krRivalryMeterHelp').on('scroll.krRivalryMeterHelp resize.krRivalryMeterHelp', function() {
      var $activeTrigger = $('.rivalry-meter-help:focus, .rivalry-meter-help:hover').first();
      if ($tooltip.hasClass('is-visible') && $activeTrigger.length) {
        positionTooltip($activeTrigger);
      } else {
        hideTooltip();
      }
    });
  }

  function drawCharts() {
    $('.kr-chart').each(function() {
      var $chart = $(this),
          chartType = $chart.data('chart-type'),
          data = $chart.data('chart-data'),
          title = $chart.data('chart-title'),
          id = $chart.attr('id'),
          options = $chart.data('chart-options') || {};

      options.title = title;

      var chart = new KR_Chart($, id, chartType, data, options);
      self.charts.push(chart);

      if ($chart.is(':visible')) {
        chart.drawChart();
      }

      /*var observer = new MutationObserver(function(mutationsList, observer) {
        $.each(mutationsList, function(mutation) {
          if (mutation.type === 'childList') {
            console.log('A child node has been added or removed.');
          }
        });
      });
      observer.observe(document.querySelector('#eael-advance-tabs-6bde91d .eael-tab-inline-icon'), {
        childList: true, subtree: false, attributes: true
      });*/
    });
  }

  function gstatic_OnLoadCallback() {
    drawCharts();
    //$('#eael-advance-tabs-6bde91d .eael-tabs-content > div').each(function() {
    $('.team-chart-tabs .tab-content > .tab-pane, #eael-advance-tabs-6bde91d .eael-tabs-content > div').each(function() {
      var observer = new MutationObserver(function(mutations, observer) {
        $.each(mutations, function(index, mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            var $target = $(mutation.target);
            if ($target.hasClass('active')) {
              drawCharts();
            }
          }
        });
      });
      observer.observe(this, { attributes: true });
    });
    /*$('#eael-advance-tabs-6bde91d .eael-tabs-nav li').on('click', function() {
      console.log('active: '+$('#eael-advance-tabs-6bde91d .eael-tabs-content .active .kr-chart').attr('id'));
    });*/
  }

  function init() {
    if ($('.kr-chart').length > 0) {
      if (typeof google === 'undefined') {
        $.getScript('https://www.gstatic.com/charts/loader.js')
          .done(function (data) {
            google.charts.load('current', {'packages':['bar']});
            google.charts.setOnLoadCallback(gstatic_OnLoadCallback);
          }).fail(function (jqXHR, textStatus, errorThrown) { 
            console.log("Error loading " + jsonDataName + " JSON data: " + textStatus)
          });
      }
    }

    if ($('.div-filters').length > 0) {
      $('.div-filters').on('change', function() {
        var division = $(this).val();

         $('.team-list .list-group-item').each(function(){
          var divsfo = $(this).data('divs'); 
          
          divsfo = divsfo.split(',');
          if(divsfo.indexOf(division) >= 0){
            $(this).show();
          }
          else{
            $(this).hide();
          }
        });
      });
    }

    if ($('.rivalry-meter-help').length > 0) {
      initRivalryMeterHelp();
    }

    if ($('.kr-rivalry-recipe-chart').length > 0) {
      drawRivalryRecipes();
      $(window).on('resize', function() {
        drawRivalryRecipes();
      });
    }

    if ($('.kr-hostility-chart').length > 0) {
      drawHostilityCharts();
      $(window).on('resize', function() {
        drawHostilityCharts();
      });
    }
  }

  init();
}

var kr = new KR(jQuery);
